var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header page-home"},[_c('div',{staticClass:"text"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.agreementData.name))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.agreementData.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }